import React, { useCallback, useContext, useEffect, useState } from 'react';
import { apiClient, closeSocket, createSocket, getApiBaseUrl, hasIgnoreMaintenancePermission } from '../../utils';
import { UserContext } from '../contexts';

export function Maintenance(props: any) {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [ready, setReady] = useState(false);
  const { user, setUser } = useContext(UserContext);

  const startLogin = () => {
    const url = getApiBaseUrl() + '/login';
    window.location.href = url;
  };

  const logout = useCallback(() => {
    apiClient
      .get('logout')
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        setUser(undefined);
        setIsMaintenance(true);
        setReady(true);
        closeSocket();
      });
  }, [setUser]);

  const checkMe = useCallback(() => {
    apiClient
      .get('users/me')
      .then((response: any) => {
        const responseUser = response.data;
        if (!responseUser.email) {
          startLogin();
        }
        if (hasIgnoreMaintenancePermission(response.data)) {
          setUser(responseUser);
          setReady(true);
          createSocket();
        } else {
          logout();
        }
      })
      .catch(() => {
        startLogin();
      });
  }, [logout, setUser]);

  const loadMaintenanceSetting = useCallback(() => {
    apiClient
      .get('/system-settings/SYSTEM_MAINTENANCE')
      .then((response: any) => {
        if (response.data?.value === '1') {
          if (user) {
            if (hasIgnoreMaintenancePermission(user)) {
              setReady(true);
            } else {
              logout();
            }
          } else {
            checkMe();
          }
        } else {
          setReady(true);
        }
      })
      .catch(() => {
        setReady(true);
      });
  }, [checkMe, logout, user]);

  useEffect(() => {
    loadMaintenanceSetting();
  }, [loadMaintenanceSetting]);

  if (!ready) {
    return null;
  }

  if (isMaintenance) {
    return (
      <div style={{ height: '100vh', padding: '15rem 0', textAlign: 'center' }}>
        <h1>Ana Veri Yönetim Uygulaması</h1>
        <h3>Uygulama geçici bir süre için bakım durumundadır, lütfen daha sonra tekrar deneyiniz.</h3>
        <p>
          Detaylı bilgi için <a href="mailto:anaveridestek@rsnet2.com.tr">anaveridestek@rsnet2.com.tr</a> adresiyle iletişime
          geçebilirsiniz.
        </p>
      </div>
    );
  }

  return <>{props.children}</>;
}
